import type { AtlasFrame, AtlasManifest } from "./types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function parseFrame(frameValue: unknown): AtlasFrame | null {
  if (!isRecord(frameValue)) {
    return null;
  }
  const x = frameValue.x;
  const y = frameValue.y;
  const w = frameValue.w;
  const h = frameValue.h;
  if (
    typeof x !== "number" ||
    typeof y !== "number" ||
    typeof w !== "number" ||
    typeof h !== "number"
  ) {
    return null;
  }
  if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(w) || !Number.isFinite(h)) {
    return null;
  }
  if (x < 0 || y < 0 || w <= 0 || h <= 0) {
    return null;
  }
  return { x, y, w, h };
}

export function parseTexturePackerHash(json: unknown): AtlasManifest | null {
  if (!isRecord(json)) {
    return null;
  }
  const framesValue = json.frames;
  if (!isRecord(framesValue)) {
    return null;
  }

  const frames: Record<string, AtlasFrame> = {};
  for (const [name, frameEntry] of Object.entries(framesValue)) {
    if (!isRecord(frameEntry)) {
      continue;
    }
    const parsed = parseFrame(frameEntry.frame);
    if (parsed == null) {
      continue;
    }
    frames[name] = parsed;
  }

  if (Object.keys(frames).length === 0) {
    return null;
  }

  let imagePath = "atlas.png";
  let cacheKey: string | undefined;
  if (isRecord(json.meta) && typeof json.meta.image === "string" && json.meta.image.length > 0) {
    imagePath = json.meta.image;
  }
  if (isRecord(json.meta)) {
    if (typeof json.meta.cacheKey === "string" && json.meta.cacheKey.length > 0) {
      cacheKey = json.meta.cacheKey;
    } else if (typeof json.meta.hash === "string" && json.meta.hash.length > 0) {
      cacheKey = json.meta.hash;
    } else if (typeof json.meta.version === "string" && json.meta.version.length > 0) {
      cacheKey = json.meta.version;
    } else if (typeof json.meta.version === "number" && Number.isFinite(json.meta.version)) {
      cacheKey = String(json.meta.version);
    }
  }

  return { imagePath, frames, cacheKey };
}

export function getFrame(manifest: AtlasManifest, id: string): AtlasFrame | null {
  return manifest.frames[id] ?? null;
}
